import React from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import { useTranslation } from 'react-i18next';
import deleteIcon from '../../../../images/delete.png';
import TextFieldNumber from '../../../../components/TextFieldNumber';
import {
  FormWrapper,
  StyledRadio,
  StyledFormLabel,
  StyledFormControlLabel,
  StyledFormControl,
  InputWrapper,
  BottomHorizontalLine,
  Icon,
} from '../index.styles';
import { commutingData } from '../data';
import { Typography } from '@mui/material';

export default function CommutingForm({
  idx,
  setForms,
  forms,
}: {
  idx: number;
  setForms: Function;
  forms: any;
}) {
  const { t } = useTranslation();
  const handleCommutingChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newForms = [...forms];
    const commutingType = newForms[idx];
    commutingType.type_of_commute_transport = (
      event.target as HTMLInputElement
    ).value;
    setForms(newForms);
  };

  const setCommutingTimePerWeek = (value: string) => {
    const newForms = [...forms];
    const commutingType = newForms[idx];
    commutingType.times_per_week = value;
    setForms(newForms);
  };

  const setCommutingAverageDistance = (value: string) => {
    const newForms = [...forms];
    const commutingType = newForms[idx];
    commutingType.average_distance_one_way_km = value;
    setForms(newForms);
  };

  return (
    <FormWrapper>
      <StyledFormControl>
        <StyledFormLabel id="commuting-radio">
          {t('employee-survey.label')}
        </StyledFormLabel>
        <Typography variant="subtitle2">
          {t('employee-survey.disclaimer')}
        </Typography>
        <br />
        <RadioGroup
          aria-labelledby="commuting-radio"
          name="commuting-buttons-group"
          value={forms[idx].type_of_commute_transport}
          onChange={handleCommutingChange}
        >
          {commutingData.map((el) => (
            <StyledFormControlLabel
              key={el.value}
              value={el.value}
              control={<StyledRadio />}
              label={t(`employee-survey.${el.value}`)}
            />
          ))}
        </RadioGroup>
      </StyledFormControl>
      <InputWrapper>
        <TextFieldNumber
          type="integer"
          label={t('employee-survey.times_per_week')}
          active
          error={false}
          index={1}
          value={
            forms[idx].times_per_week === null ? '' : forms[idx].times_per_week
          }
          setValue={(e: string) => setCommutingTimePerWeek(e)}
        />
      </InputWrapper>
      <InputWrapper>
        <TextFieldNumber
          label={t('employee-survey.average_distance_one_way_km')}
          active
          error={false}
          index={1}
          value={
            forms[idx].average_distance_one_way_km === null
              ? ''
              : forms[idx].average_distance_one_way_km
          }
          setValue={setCommutingAverageDistance}
        />
      </InputWrapper>
      {forms.length >= 2 && (
        <>
          <BottomHorizontalLine />
          <Icon
            src={deleteIcon}
            onClick={() => {
              const newForms = [...forms];

              newForms.splice(idx, 1);

              setForms(newForms);
            }}
          />
        </>
      )}
    </FormWrapper>
  );
}
